import React, { useCallback, useEffect, useRef, useState } from "react";
import { ImStatsDots } from "react-icons/im";
import VisitorChart from "../Componant/VisitorChart";
import DateRangeCalendar from "../Componant/DateRangeCalendar";
import { Row, Col, Card, Table, Dropdown, ListGroup } from "react-bootstrap";
import { FaUsers, FaComments, FaEye, FaChartLine } from "react-icons/fa";
import {
  HiArrowLongRight,
  HiMiniArrowTrendingDown,
  HiMiniArrowTrendingUp,
} from "react-icons/hi2";
import {
  TbArrowBigDownLinesFilled,
  TbArrowBigUpLinesFilled,
} from "react-icons/tb";
import { superAdminMetaServices } from "../../APIServices/MetaManagement/superAdminMetaServices";
import Moment from "react-moment";
import { BiCategory } from "react-icons/bi";

import { ChatSocket } from "../../APIServices/GoServerApi/chatService";
import { inboxServices } from "../../APIServices/SitePilotManagement/inboxServices";
import { useApp } from "../../APIHelpers/AppContext";
import { LuSquareArrowOutUpRight } from "react-icons/lu";
import { useLiveDuration } from "../../Hooks/DurationHook";

const DashboardData = ({ currentUserData, openModule }) => {
  const [currentMonth, setCurrentMonth] = useState(new Date());
  const [selectedPreset, setSelectedPreset] = useState("Live Now");
  const [visitorLoader, setVisitorLoader] = useState(false);
  const [blogLoader, setBlogLoader] = useState(false);
  const [trackLoader, setTrackLoader] = useState(false);
  const [adminBlogPostList, setAdminBlogPostList] = useState([]);
  const [adminBlogPostListCount, setAdminBlogPostListCount] = useState(0);
  const [trackingData, setTrackingData] = useState("");
  const [visitors, setVisitors] = useState([]);

  const { handleChatClick } = useApp();

  const getGreeting = () => {
    const hour = new Date().getHours();

    if (hour < 12) return "Good Morning";
    if (hour < 17) return "Good Afternoon";
    if (hour < 21) return "Good Evening";
    return "Good Night";
  };

  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const totalPages = Math.ceil(adminBlogPostListCount / itemsPerPage);

  const getAdminBlogPostList = async () => {
    setBlogLoader(true);
    let data = await superAdminMetaServices.getAdminBlogPostList(
      "published",
      "",
      pageNumber,
      itemsPerPage,
    );
    setAdminBlogPostList(data?.data || []);
    setAdminBlogPostListCount(data?.count || 0);
    setBlogLoader(false);
  };

  const getDashboardTrackingCount = async () => {
    setTrackLoader(true);
    let data = await inboxServices.getDashboardTrackingCount();
    setTrackingData(data?.data || "");
    setTrackLoader(false);
  };

  useEffect(() => {
    getAdminBlogPostList();
    getDashboardTrackingCount()
  }, [pageNumber, itemsPerPage]);

  const getInboxList = useCallback(async () => {
    setVisitorLoader(true);
    const response = await inboxServices.getInboxList(
      "liveChat",
      "visitorOpen",
      "",
      1,
      10
    );

    setVisitors(response?.data || []);
    setVisitorLoader(false);
  }, []);

  const updateInboxList = useCallback(async (inboxId, sessionId) => {
    const inbox = await inboxServices.getSingleInbox(inboxId, sessionId);
    const inboxData = inbox?.data;
    if (!inboxData || !inboxData._id || !inboxData.inboxId || !inboxData.sessionId) {
      return;
    }
    const messages = inboxData?.messages || [];
    const onlyMessages = messages.filter((m) => m.type === "message");
    const notifications = messages.filter((m) => m.type !== "message");
    const lastMessage = onlyMessages[onlyMessages.length - 1];

    const newObj = {
      ...inboxData,
      totalNotification: notifications.length,
      totalMessage: onlyMessages.length,
      lastMessage: lastMessage?.message || "",
      lastRepliedBy: lastMessage?.userType || "",
      lastReplaiedDT: lastMessage?.createdAt || "",
      chatStatus: inboxData?.chatStatus ?? "",
      sessionStatus: inboxData?.sessionStatus ?? "",
      updatedAt: inboxData?.updatedAt ?? new Date(),
    };

    setVisitors((prev) => {
      const index = prev.findIndex(
        (item) =>
          item.inboxId === inboxId &&
          item.sessionId === sessionId
      );

      if (index !== -1) {
        const updated = [...prev];
        updated[index] = {
          ...updated[index],
          ...newObj,
        };
        return updated;
      }

      return [...prev, newObj];
    });
  }, []);

  const updateInboxListRef = useRef(updateInboxList);

  useEffect(() => {
    updateInboxListRef.current = updateInboxList;
  }, [updateInboxList]);

  useEffect(() => {
    if (openModule === "dashboard") {
      getInboxList()
    }
    const sock = new ChatSocket({
      userId: "admin",
      name: "admin",
      autoReconnect: true,
      onError: (e) => console.log("ADMIN WS ERROR", e),
      onOpen: () => console.log("ADMIN WS OPEN"),
      onEvent: (type, data) => {
        if (openModule === "dashboard" && (type === "visitor:opened" || type === "message:new") && (data?.visitorId && data?.sessionId)) {
          updateInboxListRef.current(
            data.visitorId,
            data.sessionId
          );
        }
      },
    });

    console.log("sock", sock);

    sock.connect();
    return () => {
      sock.disconnect();
    };
  }, []);

  const getSingleInbox = async (inboxId, sessionId) => {
    let data = await inboxServices.getSingleInbox(inboxId, sessionId);
    handleChatClick(data?.data || "");
  };

  const VisitorRow = ({ key, item }) => {
    const liveDuration = useLiveDuration(item.startedDT, !(item.chatStatus === "closed" || item.sessionStatus === "closed"));
    return (
      <tr key={key}>
        <td>
          <div
            className="d-flex align-items-center gap-2"
          >
            <img
              src={item?.icon}
              alt={item?.name}
              style={{
                width: 32,
                height: 32,
                borderRadius: "100%"
              }}
            />
            {item?.type === "inbox" ?
              <div>
                <div className="fw-medium">{item.name}</div>
                <small className="text-muted">
                  {item.email}
                </small>
              </div>
              :
              <div>
                <div className="fw-medium">{item.inboxId}</div>
              </div>
            }
          </div>
        </td>
        <td>{item.totalMessage || 0}</td>
        <td>{item.totalNotification || 0}</td>
        <td>
          <span
            className={`text-capitalize badge ${item.chatStatus === "browsing"
              ? "bg-warning"
              : item.chatStatus === "open"
                ? "bg-danger"
                : "bg-success"
              }`}
          >
            {item.chatStatus}
          </span>
        </td>

        <td>{liveDuration}</td>

        <td>
          <Moment format="DD MMM YYYY | HH:mm" withTitle>
            {item?.createdAt}
          </Moment>
        </td>

        <td className="text-center">
          <LuSquareArrowOutUpRight
            className="CP"
            onClick={() => getSingleInbox(item?.inboxId, item?.sessionId)}
          />
        </td>
      </tr>
    );
  };

  return (
    <div className="dashboard-wrapper p-0">
      <div className="text-center border-bottom p-3">
        <h4 className="dashboard-title m-0">
          {getGreeting()}! {currentUserData?.name}
        </h4>
        <p className="m-0">Welcome to your dashboard</p>
      </div>
      <div
        className="p-3 overflow-auto"
        style={{ height: "calc(100vh - 143px)" }}
      >
        <Row className="g-3">
          <Col lg={6}>
            <Card className="dashboard-card h-100">
              <Card.Header className="border-bottom card-header-flex">
                <span className="fw-bold">Live Visitors</span>
                <div className="preview-switcher justify-content-end text-nowrap">
                  <Dropdown align="end">
                    <Dropdown.Toggle className="profile-btn px-3">
                      <ImStatsDots /> {selectedPreset}
                    </Dropdown.Toggle>

                    <Dropdown.Menu
                      align="end"
                      className="profile-menu p-0 z-1 bg-white"
                    >
                      <DateRangeCalendar
                        currentMonth={currentMonth}
                        setCurrentMonth={setCurrentMonth}
                        selectedPreset={selectedPreset}
                        setSelectedPreset={setSelectedPreset}
                      />
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </Card.Header>
              <Card.Body className="p-1">
                <VisitorChart />
              </Card.Body>
            </Card>
          </Col>

          <Col lg={6}>
            <Row className="g-3">
              <Col md={6}>
                <StatCard
                  icon={<FaUsers />}
                  title="Visitors"
                  value={trackingData?.totalVisitor || 0}
                  trend="-93.3%"
                  trendDown
                />
              </Col>

              <Col md={6}>
                <StatCard
                  icon={<FaComments />}
                  title="Chats"
                  totalAnsweredMsg={trackingData?.totalAnsweredMsg || 0}
                  totalMissedMsg={trackingData?.totalMissedMsg || 0}
                  split
                />
              </Col>

              <Col md={6}>
                <StatCard
                  icon={<FaEye />}
                  title="Page Views"
                  value={trackingData?.totalPageView || 0}
                  trend="+93.3%"
                />
              </Col>

              <Col md={6}>
                <Card className="dashboard-card h-100">
                  <Card.Body>
                    <div className="stat-header">
                      <FaChartLine className="icon info" />
                      <strong>Reporting</strong>
                    </div>

                    <StatLine label="Positive Sentiment" down />
                    <StatLine label="Engagement" down />
                    <StatLine label="Availability" up value="1.9%" />
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Col>

          <Col lg={6}>
            <Card className="dashboard-card h-100">
              <Card.Header className="border-bottom">History</Card.Header>
              <Table hover responsive className="contacts-table">
                <thead>
                  <tr>
                    <th>Visitor</th>
                    <th>Messages</th>
                    <th>Notifications</th>
                    <th>Status</th>
                    <th>Duration</th>
                    <th>Start Date | Time</th>
                    <th className="text-center">Chat</th>
                  </tr>
                </thead>
                <tbody>
                  {visitors?.map((item, index) => (
                    <VisitorRow
                      key={item.inboxId || index}
                      item={item}
                    />
                  ))}
                </tbody>
              </Table>
            </Card>
          </Col>
          <Col lg={6}>
            <Card className="dashboard-card h-100">
              <Card.Header className="border-bottom">
                What’s the latest
              </Card.Header>
              <Card.Body className="overflow-auto p-0" style={{ height: 150 }}>
                <ListGroup className="rounded-0">
                  {adminBlogPostList?.map((item, index) => (
                    <ListGroup.Item
                      key={index}
                      action
                      className="d-flex border-0 border-bottom gap-3 align-items-start CP CardHover"
                    >
                      <img
                        src={item?.icon}
                        alt="Update"
                        style={{ width: 90, height: "auto", objectFit: "cover" }}
                        className="rounded"
                      />

                      <div>
                        <h6 className="fw-semibold mb-1" style={{ fontSize: 14 }}>
                          {item?.title}
                        </h6>

                        <small
                          className="text-muted mb-2 hstack justify-content-between"
                          style={{ fontSize: 11 }}
                        >
                          <div className="hstack gap-1">
                            <BiCategory /> {item?.categoryName} <HiArrowLongRight /> {item?.subCategoryName}
                          </div>
                          <span className="fw-medium"> Published Date | Time :{" "}
                            <Moment format="DD MMM YYYY | HH:mm" withTitle>
                              {item?.createdAt}
                            </Moment>
                          </span>
                        </small>

                        <p className="text-muted mb-2" style={{ fontSize: 12 }}>
                          {item?.shortDescription}
                        </p>

                        <a
                          href="#"
                          className="fw-medium text-success text-decoration-none"
                          style={{ fontSize: 12 }}
                        >
                          Read More
                        </a>
                      </div>
                    </ListGroup.Item>
                  ))}
                </ListGroup>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
};

const StatCard = ({ icon, title, value, trend, trendDown, split, totalAnsweredMsg, totalMissedMsg }) => (
  <Card className="dashboard-card h-100">
    <Card.Body>
      <div className="stat-header">
        <span className="icon">{icon}</span>
        <strong>{title}</strong>
      </div>

      {split ? (
        <div className="d-flex justify-content-between mt-2">
          <StatMini label="Answered" value={totalAnsweredMsg} />
          <StatMini label="Missed" value={totalMissedMsg} />
        </div>
      ) : (
        <>
          <small className="text-muted">Today</small>
          <div className="stat-value">
            <h5>{value}</h5>
            <span className={trendDown ? "down" : "up"}>
              {trendDown ? (
                <HiMiniArrowTrendingDown />
              ) : (
                <HiMiniArrowTrendingUp />
              )}{" "}
              {trend}
            </span>
          </div>
        </>
      )}

      <small className="text-muted">
        Last 7 days
        <span className="up ms-2">
          <TbArrowBigUpLinesFilled /> 20
        </span>
        <span className="down ms-2">
          <TbArrowBigDownLinesFilled /> 2
        </span>
      </small>
    </Card.Body>
  </Card>
);

const StatMini = ({ label, value }) => (
  <div>
    <small className="text-muted">{label}</small>
    <div className="stat-value">
      <h5>{value}</h5>
      <span className="down">
        <HiMiniArrowTrendingDown /> 93.3%
      </span>
    </div>
  </div>
);

const StatLine = ({ label, up, value = "0%" }) => (
  <div className="d-flex justify-content-between">
    <small className="text-muted">{label}</small>
    <span className={up ? "up" : "down"}>
      {up ? <HiMiniArrowTrendingUp /> : <HiMiniArrowTrendingDown />} {value}
    </span>
  </div>
);

export default DashboardData;
